// extracted by mini-css-extract-plugin
module.exports = {"fields":"ReportTypeSelection_fields__2LcHk","field":"ReportTypeSelection_field__1oslf","reportNumber":"ReportTypeSelection_reportNumber__3oz1s"};